enum Technology {
  RASPBERRY_PI = 'Raspberry Pi',
  ARDUINO = 'Arduino',
  MICRO_BIT = 'micro:bit',
  MAKEY_MAKEY = 'Makey Makey',
  ROBOTS = 'Robots',
  TABLET = 'Tablet',
  ANDROID_PHONE = 'Android Phone',
  IPHONE = 'iPhone',
  THREE_D_PRINTER = '3D Printer',
  MAKERSPACE_SUPPLIES = 'Makerspace Supplies (Play-Doh, LEGO, etc)',
  OTHER = 'Other', // Other will show as whatever text the user entered
}

export default Technology;
